import { render, staticRenderFns } from "./SectionList.vue?vue&type=template&id=f25ffe84&scoped=true&"
import script from "./SectionList.vue?vue&type=script&lang=ts&"
export * from "./SectionList.vue?vue&type=script&lang=ts&"
import style0 from "./SectionList.vue?vue&type=style&index=0&id=f25ffe84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f25ffe84",
  null
  
)

export default component.exports